export enum translationKeys {
  EMAIL_SCREEN_SUBTITLE = 'EMAIL_SCREEN_SUBTITLE',
  EMAIL_SCREEN_TITLE = 'EMAIL_SCREEN_TITLE',
  FOOTER_BUTTON_LABEL = 'FOOTER_BUTTON_LABEL',
  VALID_EMAIL_ADDRESS_MESSAGE = 'VALID_EMAIL_ADDRESS_MESSAGE',
  EMAIL_INPUT_PLACEHOLDER = 'EMAIL_INPUT_PLACEHOLDER',
  EMAIL_INPUT_LABEL = 'EMAIL_INPUT_LABEL',
  PASSWORD_INPUT_PLACEHOLDER = 'PASSWORD_INPUT_PLACEHOLDER',
  PASSWORD_INPUT_LABEL = 'PASSWORD_INPUT_LABEL',
  PASSWORD_SCREEN_TITLE_NEW = 'PASSWORD_SCREEN_TITLE_NEW',
  PASSWORD_SCREEN_TITLE_EXISTING = 'PASSWORD_SCREEN_TITLE_EXISTING',
  PASSWORD_SCREEN_PLACEHOLDER_EXISTING = 'PASSWORD_SCREEN_PLACEHOLDER_EXISTING',
  PASSWORD_SCREEN_VALIDATION_MESSAGE = 'PASSWORD_SCREEN_VALIDATION_MESSAGE',
  PASSWORD_SCREEN_FORGOT_PASSWORD_LABEL = 'PASSWORD_SCREEN_FORGOT_PASSWORD_LABEL',
  OTP_SCREEN_TITLE = 'OTP_SCREEN_TITLE',
  OTP_SCREEN_SUBTITLE = 'OTP_SCREEN_SUBTITLE',
  OTP_SCREEN_FOOTER_BUTTON_LABEL = 'OTP_SCREEN_FOOTER_BUTTON_LABEL',
  REGION_SCREEN_TITLE = 'REGION_SCREEN_TITLE',
  REGION_SCREEN_SUBTITLE = 'REGION_SCREEN_SUBTITLE',
  REGION_SCREEN_FOOTER_BUTTON_LABEL = 'REGION_SCREEN_FOOTER_BUTTON_LABEL',
  REGION_SCREEN_COUNTRY_LABEL = 'REGION_SCREEN_COUNTRY_LABEL',
  REGION_SCREEN_DISCLAIMER = 'REGION_SCREEN_DISCLAIMER',
  PASSWORD_INSTRUCTIONS_LABEL = 'PASSWORD_INSTRUCTIONS_LABEL',
  PASSWORD_RULE_MIN_LENGTH = 'PASSWORD_RULE_MIN_LENGTH',
  PASSWORD_RULE_ONE_LOWERCASE = 'PASSWORD_RULE_ONE_LOWERCASE',
  PASSWORD_RULE_ONE_NUMBER = 'PASSWORD_RULE_ONE_NUMBER',
  PASSWORD_RULE_NO_INVALID_SYMBOLS = 'PASSWORD_RULE_NO_INVALID_SYMBOLS',
  PASSWORD_RULE_NOT_EMAIL = 'PASSWORD_RULE_NOT_EMAIL',
  OTP_SCREEN_RESEND_COUNTDOWN = 'OTP_SCREEN_RESEND_COUNTDOWN',
  OTP_SCREEN_RESEND_PROMPT = 'OTP_SCREEN_RESEND_PROMPT',
  OTP_SCREEN_RESEND_LABEL = 'OTP_SCREEN_RESEND_LABEL',
  CONTACT_WERE_HERE_FOR_YOU = 'CONTACT_WERE_HERE_FOR_YOU',
  SAVE_CLOSE_PANEL = 'SAVE_CLOSE_PANEL',
  CLOSE = 'CLOSE',
  HERE_FOR_YOU = 'HERE_FOR_YOU',
  SUPPORT_TEAM_AVAILABILITY_TEXT = 'SUPPORT_TEAM_AVAILABILITY_TEXT',
  REGION_SCREEN_COUNTRY_PLACEHOLDER = 'REGION_SCREEN_COUNTRY_PLACEHOLDER',
  REGION_SCREEN_COUNTRY_NAMES = 'REGION_SCREEN_COUNTRY_NAMES',
  EXISTING_ACCOUNT_MESSAGE = 'EXISTING_ACCOUNT_MESSAGE',
  EXISTING_ACCOUNT_TITLE = 'EXISTING_ACCOUNT_TITLE',
  THANK_YOU_REVIEWING_BODY = 'THANK_YOU_REVIEWING_BODY',
  THANK_YOU_DEMO_READY_HEADING = 'THANK_YOU_DEMO_READY_HEADING',
  THANK_YOU_DEMO_READY_LOGIN_LIVE = 'THANK_YOU_DEMO_READY_LOGIN_LIVE',
  THANK_YOU_DEMO_READY_LOGIN_DEMO = 'THANK_YOU_DEMO_READY_LOGIN_DEMO',
  THANK_YOU_COPY_LINK = 'THANK_YOU_COPY_LINK',
  THANK_YOU_QR_CODE_HEADING = 'THANK_YOU_QR_CODE_HEADING',
  THANK_YOU_ADDON_BODY = 'THANK_YOU_ADDON_BODY',
  THANK_YOU_ADDON_OPTIONS_TITLE = 'THANK_YOU_ADDON_OPTIONS_TITLE',
  THANK_YOU_ADDON_OPTIONS_BODY_1 = 'THANK_YOU_ADDON_OPTIONS_BODY_1',
  THANK_YOU_ADDON_OPTIONS_BODY_2 = 'THANK_YOU_ADDON_OPTIONS_BODY_2',
  THANK_YOU_ADDON_OPTIONS_BODY_3 = 'THANK_YOU_ADDON_OPTIONS_BODY_3',
  THANK_YOU_CORPORATE_DESKTOP_LINK = 'THANK_YOU_CORPORATE_DESKTOP_LINK',
  THANK_YOU_CORPORATE_STEP = 'THANK_YOU_CORPORATE_STEP',
  THANK_YOU_CORPORATE_COMPLETE = 'THANK_YOU_CORPORATE_COMPLETE',
  THANK_YOU_METATRADER_LOGIN_CTA = 'THANK_YOU_METATRADER_LOGIN_CTA',
  THANK_YOU_DEMO_READY_TITLE = 'THANK_YOU_DEMO_READY_TITLE',
  THANK_YOU_APPLICATION_RECEIVED_TITLE = 'THANK_YOU_APPLICATION_RECEIVED_TITLE',
  THANK_YOU_SUMSUB_BODY = 'THANK_YOU_SUMSUB_BODY',
  THANK_YOU_BUTTON_CLOSE = 'THANK_YOU_BUTTON_CLOSE',
  FINISH = 'FINISH',
  THANK_YOU_BUTTON_LOG_IN = 'THANK_YOU_BUTTON_LOG_IN',
  THANK_YOU_CLOSE_TAB_BODY = 'THANK_YOU_CLOSE_TAB_BODY',
  NOT_AVAILABLE_MOBILE = 'NOT_AVAILABLE_MOBILE',
  THANK_YOU_SPECTRE_TITLE = 'THANK_YOU_SPECTRE_TITLE',
  ADDRESS_MANUAL_VERIFICATION = 'ADDRESS_MANUAL_VERIFICATION',
  ADDRESS_MANUAL_VERIFICATION_WITH_LOOKUP = 'ADDRESS_MANUAL_VERIFICATION_WITH_LOOKUP',
  ADDRESS_LINE_1 = 'ADDRESS_LINE_1',
  ADDRESS_LINE_2 = 'ADDRESS_LINE_2',
  ADDRESS_LINE_3 = 'ADDRESS_LINE_3',
  TOWN_OR_CITY = 'TOWN_OR_CITY',
  POSTCODE = 'POSTCODE',
  COUNTRY = 'COUNTRY',
  FIELD_IS_MANDATORY = 'FIELD_IS_MANDATORY',
  SWITCH_TO_POSTCODE_LOOKUP = 'SWITCH_TO_POSTCODE_LOOKUP',
  TOWN_CITY = 'TOWN_CITY',
  EMAIL_SCREEN_DISCLAIMER = 'EMAIL_SCREEN_DISCLAIMER',
  ENTER_YOUR_ONE_TIME_CODE = 'ENTER_YOUR_ONE_TIME_CODE',
  THANK_YOU_TITLE = 'THANK_YOU_TITLE',
  THANK_YOU_CORPORATE_TITLE = 'THANK_YOU_CORPORATE_TITLE',
  ADDRESS_ENTER_YOUR_POSTCODE_PLACEHOLDER = 'ADDRESS_ENTER_YOUR_POSTCODE_PLACEHOLDER',
  NO_ADDRESS_FOUND_FOR_POSTCODE = 'NO_ADDRESS_FOUND_FOR_POSTCODE',
  ADDRESS_YOUR_SELECTED_ADDRESS_LABEL = 'ADDRESS_YOUR_SELECTED_ADDRESS_LABEL',
  ADDRESS_EDIT_IT_MANUALLY_LINK_TEXT = 'ADDRESS_EDIT_IT_MANUALLY_LINK_TEXT',
  BUNDESLAND = 'BUNDESLAND',
  BUNDESLAND_OPTIONS = 'BUNDESLAND_OPTIONS',
  BUNDESLAND_PLACEHOLDER = 'BUNDESLAND_PLACEHOLDER',
  API_ERROR_CODES_GENERIC = 'API_ERROR_CODES_GENERIC',
  API_ERROR_CODES_LOGIN_TOO_MANY_ATTEMPTS = 'API_ERROR_CODES_LOGIN_TOO_MANY_ATTEMPTS',
  API_ERROR_CODES_LOGIN_GENERIC = 'API_ERROR_CODES_LOGIN_GENERIC',
  API_ERROR_CODES_PASSWORD_BLACKLISTED = 'API_ERROR_CODES_PASSWORD_BLACKLISTED',
  START_A_CONVERSATION_NOW = 'START_A_CONVERSATION_NOW',
  ADDRESS_NO_ADDRESS_FOUND = 'ADDRESS_NO_ADDRESS_FOUND',
  ENTER_PHONE_NUMBER = 'ENTER_PHONE_NUMBER',
  APPLICATION_IN_PROGRESS = 'APPLICATION_IN_PROGRESS',
  START_NEW_APPLICATION = 'START_NEW_APPLICATION',
  SELECT_AN_APPLICATION = 'SELECT_AN_APPLICATION',
  SELECT_APPLICATION_OR_START_NEW = 'SELECT_APPLICATION_OR_START_NEW',
  APPLICATION = 'APPLICATION',
  SAVED_ON = 'SAVED_ON',
  NOT_NOW = 'NOT_NOW',
  YES_FIND_OUT_MORE = 'YES_FIND_OUT_MORE',
  LOOKING_FOR_CFDS_OPTIONS = 'LOOKING_FOR_CFDS_OPTIONS',
  CAN_ADD_CFDS_OPTIONS = 'CAN_ADD_CFDS_OPTIONS',
  SINGPASS_ERROR_MSG = 'SINGPASS_ERROR_MSG',
  TAG_RECOMMENDED = 'TAG_RECOMMENDED',
  TAG_TAKES_LONGER = 'TAG_TAKES_LONGER',
  SINGPASS_OPENED_IN_NEW_WINDOW = 'SINGPASS_OPENED_IN_NEW_WINDOW',
  RETRIEVE_MYINFO_WITH_SINGPASS = 'RETRIEVE_MYINFO_WITH_SINGPASS',
}
